import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import { message } from 'antd';

export const getActs = createAsyncThunk(
    'kitchenActs/getActs',
    async (data, { rejectWithValue }) => {
        const api = '/documents/getAcceptanceCertificatesList?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return {
                items: response.data.data,
                total: response.data.pagination.total,
            };
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const deleteAct = createAsyncThunk(
    'kitchenActs/deleteAct',
    async (data, { rejectWithValue }) => {
        const api = '/documents/deleteAcceptanceCertificate?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const getServiceAct = createAsyncThunk(
    'kitchenActs/getServiceAct',
    async (data, { rejectWithValue }) => {
        const api = '/documents/getServiceAct?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }), {
                responseType: 'blob'
            });

            if (response.data) {
                const blob = new Blob([response.data], {
                    type: 'application/pdf'
                });
                
                return blob;
            } else {
                message.error('Отсутствуют акты приема-передачи на указанный период');
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getActsStatus: null,
    deleteActStatus: null,
    acts: [],
    currentPage: 1,
    total: 0,
};

const kitchenActsSlice = createSlice({
    name: 'kitchenActs',
    initialState,
    extraReducers: (builder) => {
        builder
            // getActs
            .addCase(getActs.pending, (state) => { state.getActsStatus = 'pending'; })
            .addCase(getActs.fulfilled, (state, action) => { 
                state.getActsStatus = 'fulfilled'; 
                state.acts = action.payload?.items || action.payload || []; 
                state.total = action.payload?.total || 0; 
            })
            .addCase(getActs.rejected, (state) => { state.getActsStatus = 'rejected'; })
            
            // deleteAct
            .addCase(deleteAct.pending, (state) => { state.deleteActStatus = 'pending'; })
            .addCase(deleteAct.fulfilled, (state, action) => {
                state.deleteActStatus = 'fulfilled';
                state.acts = state.acts.map(act => 
                    act.id === action.payload.acceptanceCertificateId 
                        ? { ...act, isDeleted: 1 }
                        : act
                );
            })
            .addCase(deleteAct.rejected, (state) => { state.deleteActStatus = 'rejected'; })

            // PURGE
            .addCase(PURGE, () => { return initialState; });
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
});

export const {
    setCurrentPage,
} = kitchenActsSlice.actions;

export default kitchenActsSlice.reducer;
